import { render, staticRenderFns } from "./Clerks.vue?vue&type=template&id=9adca4b6&scoped=true&"
import script from "./Clerks.vue?vue&type=script&lang=js&"
export * from "./Clerks.vue?vue&type=script&lang=js&"
import style0 from "./Clerks.vue?vue&type=style&index=0&id=9adca4b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9adca4b6",
  null
  
)

export default component.exports